import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Dropzone from 'react-dropzone'
import imageCompression from 'browser-image-compression'

import { bytesToSize } from '../../../helpers/general'

import pdfIcon from '../../../assets/icons/pdf.png'
import pngIcon from '../../../assets/icons/png.png'
import jpgIcon from '../../../assets/icons/jpg.png'
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";

const UploadFile = ({ history, url, handleCloseModal }) => {
  const token = localStorage.getItem('token')

  const uploadHandler = async e => {
    e.preventDefault()

    if (await AlertService.confirm("", "Are you sure you want to upload this file?")) {
      try {
        let file = rawFiles[0]

        let options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1080,
          useWebWorker: true
        }

        const compressedFile = await imageCompression(file, options)
        const compressed = new File([compressedFile], file.name)

        let formData = new FormData()
        formData.append('file', compressed)

        let response = await fetch(url, {
          mode: 'cors',
          method: 'POST',
          body: formData,
          withCredentials: true,
          headers: {
            Authorization: token
          }
        })

        let responseData = await response.json()

        if (response.ok) {
          ToastUtil.success(responseData.message)
          history.push('/scheduler')
        } else {
          ToastUtil.error(responseData.message)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const cancelHandler = () => {
    setRawFiles([])
  }

  const [rawFiles, setRawFiles] = useState([])
  const [fileName, setFileName] = useState([])

  useEffect(() => {
    if (rawFiles[0]) {
      let split = rawFiles[0].name.split('.')
      let filename = split[0]
      let extension = split[1]

      if (filename.length > 10) {
        filename = filename.substring(0, 10)
        setFileName(filename + '...' + '.' + extension)
      } else {
        setFileName(rawFiles[0].name)
      }
    } else {
      setFileName('')
    }
  }, [rawFiles])

  const handleAccept = files => setRawFiles(files)

  const handleReject = event => {}

  return (
    <form
      className="d-flex flex-column justify-content-between flex-grow-1"
      onSubmit={e => uploadHandler(e)}
    >
      {rawFiles[0] ? (
        <div
          className="d-flex w-100 flex-row justify-content-between align-items-center border rounded p-4"
          style={{ backgroundColor: '#f8f8f8' }}
        >
          {rawFiles[0].type === 'image/jpeg' ||
          rawFiles[0].type === 'image/jpg' ? (
            <img src={jpgIcon} style={{ width: '50px' }} alt="" />
          ) : rawFiles[0].type === 'image/png' ? (
            <img src={pngIcon} style={{ width: '50px' }} alt="" />
          ) : rawFiles[0].type === 'application/pdf' ? (
            <img src={pdfIcon} style={{ width: '50px' }} alt="" />
          ) : (
            ''
          )}

          <div className="d-flex flex-column flex-grow-1 ml-4">
            <div>{fileName}</div>
            <small className="text-muted">
              {bytesToSize(rawFiles[0].size)}
            </small>
          </div>
        </div>
      ) : (
        <Dropzone
          multiple={false}
          onDrop={handleAccept}
          onRejected={event => handleReject(event)}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps({
                className:
                  'd-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4',
                style: { border: '2px dashed #e3e3e3' }
              })}
            >
              <input {...getInputProps()} />
              <i className="fas fa-upload fa-3x text-brand"></i>
              <p className="text-brand">Click here to upload file</p>
              <small>Max file size is 10MB.</small>
              <small>File type supported: JPEG, JPG, PNG</small>
            </div>
          )}
        </Dropzone>
      )}
      {rawFiles[0] && (
        <React.Fragment>
          <button
            type="button"
            onClick={cancelHandler}
            className="btn btn-outline-brand btn-block mt-4"
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-brand btn-block mt-2">
            Upload
          </button>
        </React.Fragment>
      )}
    </form>
  )
}

export default withRouter(UploadFile)
